import { AbstractComponent } from "@abstracts";

export default class Test extends AbstractComponent {
    constructor(_el) {
        super(_el);

        this._init();
    }

    onHashHandle() {
        console.log('do this');
    }
}